/* MUI Imports */
import { Box } from "@mui/material";
import UserRegister from "../components/auth/UserRegister/UserRegister";
import NavBar from "../components/layout/NavBar";
import BackGeneral from "../components/layout/BackGeneral";

const UserRegisterP = (props) => {
    const { userEmail, handleShowRegister, register, independentUser, invitation, language, invitationId, isLoginRedirect } = props;

    return (
        <Box sx={{
            display: "flex",
            position: "relative",
            height: "100%",
        }}>
            <NavBar register={register} independentUser={independentUser} userEmail={userEmail} />
            <Box sx={{ flexGrow: 1 }}>
                <BackGeneral>
                    <UserRegister
                        editMode={false}
                        userEmail={userEmail}
                        handleShowRegister={handleShowRegister}
                        independentUser={independentUser}
                        invitation={invitation}
                        language={language}
                        invitationId={invitationId}
                        isLoginRedirect={isLoginRedirect}
                    />
                </BackGeneral>
            </Box>
        </Box>
    );
};

export default UserRegisterP;
